// extracted by mini-css-extract-plugin
export var container = "socialLinks-module--container--dc1ca flex gap-ms4";
export var handlesContainer = "socialLinks-module--handlesContainer--2ba1c flex gap-ms2 mt-ms1";
export var handlesTitle = "socialLinks-module--handlesTitle--25d86 text-white";
export var link = "socialLinks-module--link--9442f hover_[&>*]_scale-105 hover_[&>*]_fill-primary";
export var socialIcon = "socialLinks-module--socialIcon--5b6f3 inline-block align-middle transition ease-in-out duration-300";
export var socialIconColor = "socialLinks-module--socialIconColor--1222f fill-white";
export var socialIconSize = "socialLinks-module--socialIconSize--7fb7e w-ms3 h-ms3";